export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14106.ac04bdc9.jpg";